import { getConstant } from '../utils';

export const getCultures = getConstant('GET_CULTURES');
export const getCulture = getConstant('GET_CULTURE');
export const clearCultures = getConstant('CLEAR_CULTURES');